export default __webpack_public_path__ + "static/media/guest_10_02_talita_tiemi.20345bb5.png";